import { shape, string } from 'prop-types'
import { Component } from 'react'
import { connectStateResults } from 'react-instantsearch-dom'
import { compose } from 'redux'

import { PAGE_TYPE_SEARCH_RESULTS } from 'shared/consts'
import { decorateNoveltiesSortingOptions } from 'shared/experiments/components/NoveltiesSortingOptions'
import { EXPERIMENT_VARIATION, SERP_LOAD_MORE } from 'shared/experiments/consts'
import {
  getDefaultHitsPerPage,
  getSortingItems,
} from 'shared/utils/algolia/filters'
import { withI18n } from 'shared/utils/withI18n'
import { getHitsPerPageItems } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/helpers'
import HitsPerPage from 'views/components/organisms/AlgoliaInstantSearch/Algolia/HitsPerPage'
import Pagination from 'views/components/organisms/AlgoliaInstantSearch/Algolia/Pagination'
import SortBy from 'views/components/organisms/AlgoliaInstantSearch/Algolia/SortBy'
import Experiment from 'views/components/utils/optimizely/Experiment'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { i18nType, publicRuntimeConfigType } from 'views/utils/propTypes'

import './FilterBox.scss'

import { getFilterValues } from './helpers'

class FilterBox extends Component {
  state = this.getInitialState()

  getInitialState() {
    const {
      indexName,
      searchResults,
      i18n,
      searchState: { query },
    } = this.props

    const defaultHitsPerPage = getDefaultHitsPerPage(searchResults)

    const state = {
      defaultHitsPerPage,
    }

    if (searchResults) {
      const {
        noveltiesIndexName,
        publicRuntimeConfig: {
          pageProperties: { ruleContexts },
        },
      } = this.props

      const { index } = searchResults
      const { from, to, total } = getFilterValues(searchResults)
      const hitsPerPageItems = getHitsPerPageItems()
      const isSearchResultsPage = Boolean(query)
      const sortingItems = getSortingItems({
        indexName,
        i18n,
        isSearchResultsPage,
      })

      return {
        ...state,
        index,
        from,
        to,
        total,
        hitsPerPageItems,
        sortingItems: decorateNoveltiesSortingOptions({
          sortingItems,
          ruleContexts,
          noveltiesIndexName,
          label: i18n._('general.label.sort.Novelties'),
        }),
      }
    }

    return state
  }

  componentDidUpdate(prevProps) {
    const { searchResults } = this.props

    if (searchResults !== prevProps.searchResults) {
      this.updateState(searchResults)
    }
  }

  updateState(searchResults) {
    this.setState({
      ...getFilterValues(searchResults),
    })
  }

  render() {
    const {
      index,
      from,
      to,
      total,
      hitsPerPageItems,
      sortingItems,
      defaultHitsPerPage,
    } = this.state
    const {
      i18n,
      publicRuntimeConfig: {
        pageProperties: { pageType },
      },
    } = this.props

    return (
      <div className="o-FilterBox u-position--relative">
        <p
          className="u-font-weight--bold o-FilterBox__total-products"
          data-qa-id="search-result-result-counter"
        >
          {`${from} - ${to} ${i18n._(
            'userReview.label.byCustomer'
          )} ${total} ${i18n._('general.label.sort.Produkten')}`}
        </p>
        <ul className="a-box--dark l-flex l-flex--wrap a-box a-list-reset u-hidden@print u-hidden@small-tiny o-FilterBox__filters-container">
          {hitsPerPageItems && hitsPerPageItems.length > 0 && (
            <li
              className="u-padding--right o-FilterBox__filters-container__item"
              data-qa-id="results-per-page-select"
            >
              <HitsPerPage
                items={hitsPerPageItems}
                defaultRefinement={defaultHitsPerPage}
                label={i18n._('general.label.sort.Anzeigen')}
              />
            </li>
          )}
          {sortingItems && (
            <li className="u-padding--right o-FilterBox__filters-container__item">
              <SortBy items={sortingItems} currentRefinement={index} />
            </li>
          )}

          <Experiment
            name={SERP_LOAD_MORE}
            component={'li'}
            classNames="l-flex__primary"
          >
            {({ variant }) =>
              pageType !== PAGE_TYPE_SEARCH_RESULTS ||
              variant === EXPERIMENT_VARIATION.DEFAULT ? (
                <Pagination small />
              ) : null
            }
          </Experiment>
        </ul>
      </div>
    )
  }
}

FilterBox.propTypes = {
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  indexName: string.isRequired,
  noveltiesIndexName: string,
  i18n: i18nType.isRequired,
  searchState: shape({}).isRequired,
  searchResults: shape({}),
}

FilterBox.defaultProps = {
  searchResults: null,
  noveltiesIndexName: null,
}

export default compose(
  connectStateResults,
  withI18n(),
  withShopAndRuntimeConfig
)(FilterBox)
